import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tl_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  const cid = localStorage.getItem("tl_company");
  if (cid) config.headers["X-Company-Id"] = cid;
  return config;
});
